import { render, staticRenderFns } from "./SelfTestPelletizingGriList.vue?vue&type=template&id=45afbdf8&"
import script from "./SelfTestPelletizingGriList.vue?vue&type=script&lang=js&"
export * from "./SelfTestPelletizingGriList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports